export default "__VITE_ASSET__BeA2YlBy__"